import React from "react";
import { Photo } from "./SinglePhoto.styles.js";

const preventDownload = (e) => e.preventDefault();

const SinglePhoto = ({ img, alt, ...styles }) => {
  return (
    <>
      <Photo
        src={img}
        alt={alt}
        onContextMenu={preventDownload}
        onDragStart={preventDownload}
        {...styles}
      />
    </>
  );
};

export default SinglePhoto;
